export const key = `-----BEGIN PGP PUBLIC KEY BLOCK-----
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=9w7G
-----END PGP PUBLIC KEY BLOCK-----`;
